import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../../Icon';
import { IGridDropPosition } from '../types';
import { theme } from '../../../styles/theme';
import { SingleSelect } from '../../Dropdown/SingleSelect';

export interface IBorderActionMenuProps {
  isActionsMenuShown: boolean;
  pinActionsMenu: () => void;
  closeActionsMenu: () => void;
  items: ReactNode;
  position: IGridDropPosition;
}

const Container = styled.div`
  position: absolute;
  top: calc(50% - 8px);
`;
const StyledIconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 2px;
  background-color: ${theme.colors.level0};
  &:hover {
    cursor: pointer;
  }
`;

const BorderActionsMenu = ({
  pinActionsMenu,
  closeActionsMenu,
  items,
}: IBorderActionMenuProps) => {
  return (
    <Container>
      <SingleSelect
        placement="bottom-start"
        onOpen={pinActionsMenu}
        onClose={closeActionsMenu}
        trigger={
          <StyledIconWrapper>
            <SvgIcon
              name="plus-circle"
              width={16}
              height={16}
              isActive={true}
            />
          </StyledIconWrapper>
        }
      >
        {items}
      </SingleSelect>
    </Container>
  );
};

export default BorderActionsMenu;
